import Backbone from 'backbone';
import pageContext from '@bingads-webui-static-legacy/page-context';
import _ from 'underscore';
import ko from 'knockout';
import $ from 'jquery';
import AdGroupCreationView from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/index';
import tmpl from '@bingads-webui-campaign-legacy/adgroup-create-advanced/template/mixed-mode-creation.pug';
import ViewModel from '@bingads-webui-campaign-legacy/adgroup-create-advanced/viewmodel/mixed-mode-creation';
import DSASettingsView from '@bingads-webui-campaign-legacy/dsa-settings/view/dsa-settings';
import * as scrollUtil from '@bingads-webui-component-legacy/extension/scrollTo';
import uiBlocker from '@bingads-webui-component-legacy/uiblocker/index';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import Promise from 'bluebird';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import { adGroupTypeEnum } from '@bingads-webui-campaign-legacy/adgroup-create-advanced/util/adGroupTypeEnum';
import { Dialog } from '@bingads-webui/dialog';
import { MessageView } from '@bingads-webui-campaign-legacy/adgroup-create-advanced/view/message';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class MixedModeAdGroupCreationView extends Backbone.View {
  initialize(options) {
    this.options = options;
    this.viewModel = new ViewModel();
    this.currentCampaign =  pageContext.CurrentCampaign;
    this.hasDSASettingsInCampaignSettings = _.result(_.first(_.result(this.currentCampaign, 'CampaignSettings')), 'DomainName') != null;
    this.currentAdgroupType = this.viewModel.adGroupType();
    this.campaignId = this.currentCampaign.Id;
    this.handlePopState = () => {
      this.adGroupCreationView.cancel();
    };

    window.addEventListener('popstate', this.handlePopState);
  }

  get events() {
    return {
      'click .btn-save': 'save',
      'click .btn-cancel': 'cancel',
    };
  }

  errorElements() {
    return this.$('.mixed-mode-ad-group-creation-container .error, .mixed-mode-ad-group-creation-container .alert-danger').filter(':visible');
  }

  initDSASettingsView() {
    if (this.dsaSettingsView) {
      this.dsaSettingsView.remove();
    }
    this.dsaSettingsView = new DSASettingsView();
    this.dsaSettingsView.on('change', () => {
      this.updateSubViewDSASettings();
    });
  }

  hasDisclaimerSetting(campaign) {
    const disclaimerAdsEnabled = _.chain(campaign)
      .result('CampaignSettings')
      .result('0')
      .result('DisclaimerAdsEnabled')
      .value();

    return disclaimerAdsEnabled;
  }

  updateSubViewDSASettings() {
    const dsaSettings = this.dsaSettingsView.getValues();

    if (this.adGroupCreationView.subViews['auto-targets']) {
      this.adGroupCreationView.subViews['auto-targets'].trigger('update:setting', {
        Language: dsaSettings.LanguageCode,
        DomainName: dsaSettings.DomainName,
        Source: dsaSettings.Source,
      });
    }

    if (this.adGroupCreationView.subViews.ad) {
      this.adGroupCreationView.subViews.ad.trigger('update:domainName', dsaSettings.DomainName);
      this.adGroupCreationView.subViews.ad.trigger('update:dynamicDescriptionEnabled', dsaSettings.DynamicDescriptionEnabled);
    }
  }

  renderAdGroupCreationView(adGroupType) {
    const $adGroupCreationContainer = this.$('.adgroup-creation-container');

    if (this.adGroupCreationView) {
      this.adGroupCreationView.remove();
    }
    if (adGroupType === 'SearchStandard') {
      if (this.dsaSettingsView) {
        this.dsaSettingsView.remove();
        this.dsaSettingsView = null;
      }
      this.adGroupCreationView = new AdGroupCreationView(_.extend({}, this.options, { isMixedMode: true, adGroupType: adGroupTypeEnum.SearchStandard, getCampaignPromise: this.getCampaignPromise}));
      $adGroupCreationContainer.empty().append(this.adGroupCreationView.render().$el);
    } else {
      this.adGroupCreationView = new AdGroupCreationView(_.extend({}, this.options, { isMixedMode: true, isDynamicAdGroupCreation: true, adGroupType: adGroupTypeEnum.SearchDynamic, getCampaignPromise: this.getCampaignPromise }));
      $adGroupCreationContainer.empty().append(this.adGroupCreationView.render().$el);

      if (!this.hasDSASettingsInCampaignSettings) {
        this.initDSASettingsView();
        const $dsaSettingsContainer = this.$('.adgroup-creation-dsa-settings-view-container');

        $dsaSettingsContainer.empty().append(this.dsaSettingsView.render().$el);
      }
    }
  }

  attemptSwitchadGroupType(adGroupType) {
    const dialog = new Dialog({
      backdrop: false,
      keyboard: false,
      showHeader: false,
    }).setContent(new MessageView({
      title: i18n.getString('ChangeAdGroupTypeTitle'),
      content: i18n.getString('ChangeAdGroupTypeContent'),
    }))
      .setState({
        buttons: [{
          text: i18n.getString('Button_Cancel'),
          name: 'cancel',
          class: 'confirm-cancel',
        }, {
          text: i18n.getString('Button_Continue'),
          name: 'continue',
          class: 'confirm-continue btn-primary',
        }],
      })
      .render();

    dialog.$el.appendTo(document.body);
    dialog.show();
    $('.confirm-continue').focus();

    dialog.on('clickedButton', (button) => {
      dialog.remove();
      if (button === 'continue') {
        this.viewModel.errors([]);
        this.renderAdGroupCreationView(adGroupType);
        this.currentAdgroupType = adGroupType;
      }  else  {
      // set back to original adgroup type
        this.viewModel.adGroupType(this.currentAdgroupType);
      }
    });
  }


  render() {
    this.options.perfMarker.willRender();
    const params = {
      queryParameters: {
        entitySet: edmCampaign.currentAccount.Campaigns,
        expand: ['Budget'],
      },
      bypassCache: true,
    };

    this.getCampaignPromise = this.currentCampaign && this.currentCampaign._IsAllData ? Promise.resolve(this.currentCampaign) : jsData.Campaign.find(Number(this.campaignId), params);
    this.getCampaignPromise.then((campaign) => {
      this.$el.append(tmpl({
        i18n,
      }));
      ko.applyBindings(this.viewModel, this.el);
      this.viewModel.hasDisclaimerSetting(this.hasDisclaimerSetting(campaign));

      this.renderAdGroupCreationView(this.viewModel.adGroupType());

      this.viewModel.adGroupType.subscribe((adGroupType) => {
        if (adGroupType !== this.currentAdgroupType) {
          this.attemptSwitchadGroupType(adGroupType);
        }
      });
      this.$('.adgroup-type-select').focus();
      this.options.perfMarker.done();
    });

    return this;
  }

  remove() {
    if (this.adGroupCreationView) {
      this.adGroupCreationView.remove();
    }

    if (this.dsaSettingsView) {
      this.dsaSettingsView.remove();
    }

    window.removeEventListener('popstate', this.handlePopState);
    super.remove();
  }

  save() {
    if (!this.validate()) {
      scrollUtil.scrollAndCenter(this.errorElements());
      return;
    }

    if (this.dsaSettingsView) {
      const params = this.dsaSettingsView.getValues();

      jsData.Campaign
        .update(this.campaignId, params, { adapter: 'bulk', cacheResponse: false })
        .then(() => {
          this.currentCampaign.CampaignSettings = [{
            DomainName: params.DomainName,
            Source: params.Source,
            Language: params.LanguageCode,
          }];
          this.saveTargetingSource(this.campaignId);
          window.App.state.trigger('change:campaign_id');
          this.dsaSettingsView.setValues({
            disabled: true,
          });
          this.adGroupCreationView.save();
          return true;
        })
        .catch((response) => {
          const hasErrors = response && !_.isUndefined(response.errors);

          if (hasErrors) {
            const map = new Map();
            const campaignErrors = _.filter(response.errors, (error) => {
              const key = `${error.Error},${error.ErrorNumber},${error.EditorialCode},${error.EditorialLocation},${error.Property}`;

              return error.Type === 'Campaign Error' && !map.has(key) && map.set(key, 1);
            });
            const errors = i18nErrors.getBulkApiErrors(campaignErrors);
            const propertyErrors = _.filter(errors, (err) => !!err.property);
            const globalErrors = _.chain(errors)
              .filter((err) => !err.property)
              .map((err) => err.message)
              .value();

            this.dsaSettingsView.handleApiErrors(propertyErrors);
            this.viewModel.errors(globalErrors);
            this.scrollToDSAError();
          }
          return false;
        })
        .finally(uiBlocker());
    } else {
      this.adGroupCreationView.save();
    }
  }

  saveTargetingSource(id) {
    const retPromise = id && this.dsaSettingsView && this.dsaSettingsView.targetingSource ?
      this.dsaSettingsView.targetingSource.save(id) : Promise.resolve();

    return retPromise.then((result) => {
      if (_.result(this.CurrentCampaign, 'Id') === id) {
        if (_.size(this.CurrentCampaign.CampaignSettings) > 0 && this.targetingSource) {
          this.CurrentCampaign.CampaignSettings[0].Source = this.targetingSource.koModel.source();
        }
      }
      return result;
    });
  }

  scrollToDSAError() {
    scrollUtil.scrollAndCenter(this.$('.dsa-settings-container .error'));
  }

  validate() {
    const adGroupType = this.viewModel.adGroupType();
    const isDSASettingsAvailable = (adGroupType === 'SearchDynamic') && !this.hasDSASettingsInCampaignSettings;

    // eslint-disable-next-line no-bitwise
    return (isDSASettingsAvailable ? this.dsaSettingsView.validate() : true) & this.adGroupCreationView.validate();
  }

  cancel() {
    this.adGroupCreationView.cancel();
  }
}
